import { useEffect, useState } from "react"
import Logo from "../../../assets/dashboard/logo.png"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
// import './Form.css'
import { addPolicy, getMyFeedById, getMyPolicyById, updateFeed, updatePolicy } from "../../../services/Trainer/trainer"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"

import { DescriptionEditor } from "./DescriptionEditor"

const FeedsFormPage = ({ onSubmit, onCancel }) => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const {type , id } = useParams()
  console.log("typetypetype",type)
  const [editableData, setEditableData] = useState(null)
  const [initialValues, setInitialValues] = useState({
    // title: "",
    description: "",
    images: [],
    documents: [],
  })

  const validationSchema = Yup.object({
    // title: Yup.string().required("Policy Title is required"),
    description: Yup.string().required("Policy Description is required"),
  })

  const fetchData = async () => {
    const data = await getMyFeedById(id)
    if (data?.success) {
      console.log("data>>><<<<<<<", data)
      const courseData = data.data

      // Convert backend data to editor format
      const convertedData = await convertBackendDataForEdit(courseData)

      setInitialValues({
        // title: courseData?.title || "",
        description: convertedData.description || "",
        images: convertedData.images || [],
        documents: convertedData.documents || [],
      })

      setEditableData(courseData)
    }
  }

  const convertBackendDataForEdit = async (data) => {
    let description = data.description || ""
    const images = []
    const documents = []

    // Convert existing images
    if (data.images && Array.isArray(data.images)) {
      for (let i = 0; i < data.images.length; i++) {
        const imageUrl = data.images[i]
        const imageKey = `image_${i + 1}`

        // Use bucket URL directly
        const fullImageUrl = process.env.REACT_APP_BUCKET_URL + imageUrl

        // Replace image key with full bucket URL in description
        description = description.replace(new RegExp(imageKey, "g"), fullImageUrl)

        images.push({
          file: null, // No file object for existing images
          blobUrl: fullImageUrl, // Use bucket URL directly
          isExisting: true,
          originalKey: imageKey,
          originalUrl: imageUrl, // Store relative URL for backend
          toRemove: false,
          id: `existing_img_${i}`,
        })
      }
    }

    // Convert existing documents
    if (data.documents && Array.isArray(data.documents)) {
      for (let i = 0; i < data.documents.length; i++) {
        const docUrl = data.documents[i]
        const docKey = `doc_${i + 1}`

        // Use bucket URL directly
        const fullDocUrl = process.env.REACT_APP_BUCKET_URL + docUrl

        // Replace doc key with full bucket URL in description
        description = description.replace(new RegExp(docKey, "g"), fullDocUrl)

        documents.push({
          file: null, // No file object for existing documents
          blobUrl: fullDocUrl, // Use bucket URL directly
          isExisting: true,
          originalKey: docKey,
          originalUrl: docUrl, // Store relative URL for backend
          toRemove: false,
          id: `existing_doc_${i}`,
        })
      }
    }

    return {
      description,
      images,
      documents,
    }
  }

  useEffect(() => {
    if (id) {
      fetchData()
    }
  }, [])


 const handleSubmit = async (
  values,
) => {
  let descriptionHTML = values.description || ""
  console.log("👉 Final values>>>", values)

  const formData = new FormData()
  // formData.append("title", values.title || "")
  formData.append("type", type)

  // ===== Handle IMAGES =====
  let imageCounter = 0
  const finalImages = []

  if (Array.isArray(values.images)) {
    values.images.forEach((imgObj) => {
      if (!imgObj.toRemove) {
        imageCounter++
        const imageKey = `image_${imageCounter}`

        if (imgObj.isExisting) {
          // Replace original URL with sequential key
          const bucketUrl = process.env.REACT_APP_BUCKET_URL + imgObj.originalUrl
          descriptionHTML = descriptionHTML.replace(
            new RegExp(bucketUrl.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"),
            imageKey,
          )

          finalImages.push({
            key: imageKey,
            originalUrl: imgObj.originalUrl,
            isExisting: true,
          })
        } else {
          // New upload
          const { file, blobUrl } = imgObj
          descriptionHTML = descriptionHTML.replace(blobUrl, imageKey)
          formData.append(imageKey, file)

          finalImages.push({
            key: imageKey,
            name: file.name,
            isExisting: false,
          })
        }
      }
    })
  }

  // ===== Handle DOCUMENTS =====
  let docCounter = 0
  const finalDocuments = []

  if (Array.isArray(values.documents)) {
    values.documents.forEach((docObj) => {
      if (!docObj.toRemove) {
        docCounter++
        const docKey = `doc_${docCounter}`

        if (docObj.isExisting) {
          const bucketUrl = process.env.REACT_APP_BUCKET_URL + docObj.originalUrl
          descriptionHTML = descriptionHTML.replace(
            new RegExp(bucketUrl.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"),
            docKey,
          )

          finalDocuments.push({
            key: docKey,
            originalUrl: docObj.originalUrl,
            isExisting: true,
          })
        } else {
          const { file, blobUrl } = docObj
          descriptionHTML = descriptionHTML.replace(blobUrl, docKey)
          formData.append(docKey, file)

          finalDocuments.push({
            key: docKey,
            name: file.name,
            isExisting: false,
          })
        }
      }
    })
  }

  // Add lists + description
  // formData.append("images", JSON.stringify(finalImages))
  // formData.append("documents", JSON.stringify(finalDocuments))
  formData.append("description", descriptionHTML)

  // Debug
  console.log("👉 Final description:", descriptionHTML)
  console.log("👉 Final images:", finalImages)
  console.log("👉 Final documents:", finalDocuments)
  for (const pair of formData.entries()) {
    console.log("Final values:", pair[0], pair[1])
  }

  setLoading(true)
  try {
    const result = await updateFeed(formData, id) 
    console.log("Policy processed successfully:", result)

    if (result?.success) {
      setLoading(false)
      toast.success(result?.message)
      navigate(-1)
    } else {
      setLoading(false)
      toast.error(result?.message)
    }
  } catch (err) {
    console.error("Failed to process policy:", err)
    setLoading(false)
  }
}



  return (
    <div className="row justify-content-center my-5">
      <div className="card shadow col-lg-9">
        <div className="d-flex align-items-center justify-content-center mt-4">
          <div className="text-center mb-4">
            <img src={Logo || "/placeholder.svg"} alt="Logo" width={100} />
          </div>
        </div>
        {/* <h2 className="text-center fs-4 fw-bold mb-4 text-color">{id ? "Edit Policy" : "Add Policy"}</h2> */}
        <h2 className="text-center fs-4 fw-bold mb-4 text-color">Edit {type.charAt(0).toUpperCase() + type.slice(1)}</h2>


        <div className="card-body">
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form className="mb-4 px-4">
                {/* Basic Info */}
                <div className="form-wrapper">
                  {/* <div className="form-group mb-4">
                    <Field name="title" type="text" placeholder="Policy Title" className="custom-input" />
                    <ErrorMessage name="title" component="div" className="error-text" />
                  </div> */}

                  <div className="form-group mb-4">
                    <label>{type.charAt(0).toUpperCase() + type.slice(1)} Description</label>
                    <DescriptionEditor
                      value={values.description}
                      onChange={(val) => setFieldValue("description", val)}
                      setFieldValue={setFieldValue}
                      values={values}
                      isEditMode={!!id}
                      initialData={editableData}
                    />
                    <ErrorMessage name="description" component="div" className="error-text" />
                  </div>
                </div>

                {/* Submit */}
                <div className="mt-4">
                  <button type="submit" className="text-white w-100 py-2 submit-btn" disabled={loading}>
                    {loading ? "Loading....." : id ? `Update ${type.charAt(0).toUpperCase() + type.slice(1)}` : `Update ${type.charAt(0).toUpperCase() + type.slice(1)}`}
                  </button>
                </div>

                {/* Cancel Button (optional) */}
                {onCancel && (
                  <div className="mt-2">
                    <button
                      type="button"
                      className="btn btn-outline-secondary w-100 py-2"
                      onClick={onCancel}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default FeedsFormPage
